<nav aria-label="Pagination" class="mt-10 flex flex-wrap items-center justify-center gap-2">
  <button
    type="button"
    (click)="goToPage(state().page - 1)"
    [disabled]="state().page === 1"
    class="h-10 rounded-lg border border-slate-200 px-4 text-sm font-medium text-slate-700 transition enabled:hover:border-[var(--color-primary)] enabled:hover:text-[var(--color-primary)] disabled:cursor-not-allowed disabled:opacity-40"
  >
    Prev
  </button>

  @for (page of pageNumbers(); track page) {
    <button
      type="button"
      (click)="goToPage(page)"
      [class.bg-[var(--color-primary)]]="page === state().page"
      [class.text-white]="page === state().page"
      class="h-10 min-w-10 rounded-lg border border-slate-200 px-3 text-sm font-semibold text-slate-700 transition hover:border-[var(--color-primary)]"
    >
      {{ page }}
    </button>
  }

  <button
    type="button"
    (click)="goToPage(state().page + 1)"
    [disabled]="state().page === state().totalPages"
    class="h-10 rounded-lg border border-slate-200 px-4 text-sm font-medium text-slate-700 transition enabled:hover:border-[var(--color-primary)] enabled:hover:text-[var(--color-primary)] disabled:cursor-not-allowed disabled:opacity-40"
  >
    Next
  </button>
</nav>
